<p-toast></p-toast>

<suspend-user [userId]="suspendUser.userId" [userName]="suspendUser.userName" [_displayModalSuspend]="displayModalSuspend"
              [_isLiftSuspensionAction]="isLiftSuspensionAction"
              (changedDisplayModalSuspendEmit)="changedDisplayModalSuspendEmit($event)"
              (suspendSuccessEmit)="onSuspendSuccess()"
              (liftSuspensionSuccessEmit)="onLiftSuspensionSuccess()"></suspend-user>

<banned-user *ngIf="displayModalBanned" [userId]="bannedUser.userId" [userName]="bannedUser.userName"
             [_displayModalBanned]="displayModalBanned"
             [_isLiftBanAction]="isLiftBanAction"
             (changedDisplayModalBannedEmit)="changedDisplayModalBannedEmit($event)"
             (banSuccessEmit)="onBanSuccess()"
             (liftBanSuccessEmit)="onLiftBanSuccess()"></banned-user>

<customer-transaction-detail *ngIf="isVisibleCustomerTransactionDetail"
                             [isVisibleCustomerTransactionDetail]="isVisibleCustomerTransactionDetail"
                             [_transactionId]="transactionId"
                             (changedVisibleCustomerTransactionDetailEmit)="changedVisibleCustomerTransactionDetailEmit($event)"></customer-transaction-detail>

<customer-order-detail *ngIf="isVisibleCustomerOrderDetail"
                             [isVisibleCustomerOrderDetail]="isVisibleCustomerOrderDetail"
                             [_transactionId]="orderTransactionId"
                             (changedVisibleCustomerOrderDetailEmit)="changedVisibleCustomerOrderDetailEmit($event)"></customer-order-detail>

<driver-order-detail *ngIf="isVisibleDisplayOrderDetail" [_orderId]="customer.LastOrderCompletedId"
                     (changedVisibleDisplayOrderDetailEmit)="changedVisibleDisplayOrderDetailEmit($event)"
                     [_isVisibleDisplayOrderDetail]="isVisibleDisplayOrderDetail"></driver-order-detail>

<p-dialog [(visible)]="displayConfirmDialog"
          [modal]="true"
          [style]="{ width: '40vw' }"
          [draggable]="false"
          [resizable]="false"
          [closable]="true">
    <ng-template pTemplate="item">
        <div class="modal-content-center">
            <h1>{{ customer?.IsCompanyUser ? "Remove from Company?" : "Add to Company?" }}</h1>
        </div>
        <div class="modal-content-center">
            <p>
                {{ customer?.IsCompanyUser ? "Are you sure you want to “Remove from Company“?" : "Are you sure you want to “Add to Company“?" }}
            </p>
            <br/>
        </div>
        <div class="modal-buttons-container">
            <button pButton
                    icon="pi pi-check"
                    class="p-element btn-darkblue p-button p-component mr-1"
                    label="Confirm"
                    (click)="confirmAction()"></button>
            <button pButton
                    icon="pi pi-times"
                    label="Cancel"
                    class="p-element btn-cancel p-button p-component"
                    (click)="changeConfirmDialogVisibility()"></button>
        </div>
    </ng-template>
    <ng-template pTemplate="footer"></ng-template>
</p-dialog>

<p-dialog [(visible)]="displaySubscriptionConfirmDialog"
          [modal]="true"
          [style]="{ width: '40vw', height: '40%' }"
          [draggable]="false"
          [resizable]="false"
          [closable]="true">
    <ng-template pTemplate="item">
        <div class="modal-content-center">
            <h1>{{ customer?.HasUserSubscription ? "Remove Subscription?" : "Add Subscription?" }}</h1>
        </div>
        <div class="modal-content-center">
            <p>
                {{ customer?.HasUserSubscription
                ? "Are you sure you want to “Remove Subscription?"
                : "Are you sure you want to “Add Subscription?“" }}
            </p>
            <br/>
        </div>
        <div class="modal-content-center" *ngIf="!customer?.HasUserSubscription">
            <p-dropdown
                    [options]="subscriptionProducts"
                    [(ngModel)]="selectedSubscriptionProduct"
                    optionLabel="Name"
                    placeholder="Select a subscription"
                    styleClass="w-100">
                <ng-template let-product pTemplate="item">
                    <div class="p-ml-2">
                        <div class="font-bold">{{ product.Name }}</div>
                        <div class="text-sm text-gray">{{ product.ValidityPeriodDisplay }} - ₱{{ product.Price }}</div>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>

        <br/>

        <div *ngIf="!customer?.HasUserSubscription">
            <p>Enter Receipt Number</p>
            <input type="text" pInputText class="p-inputtext-sm" [(ngModel)]="xpressSubscriptionReceiptNumber" placeholder="Please enter receipt number">
        </div>

        <div class="modal-buttons-container">
            <button pButton
                    icon="pi pi-check"
                    class="p-element btn-darkblue p-button p-component mr-1"
                    label="Confirm"
                    (click)="createOrRemoveSubscriptionCard()">
            </button>
            <button pButton
                    icon="pi pi-times"
                    label="Cancel"
                    class="p-element btn-cancel p-button p-component"
                    (click)="hideSubscriptionConfirmDialog()">
            </button>
        </div>
    </ng-template>
    <ng-template pTemplate="footer"></ng-template>
</p-dialog>

<customer-manage-discount-dialog *ngIf="visibleCustomerManageDiscountDialog"
                                 [_visibleCustomerManageDiscountDialog]="visibleCustomerManageDiscountDialog"
                                 [_userId]="customerId"
                                 [_specialDiscountType]="customer.SpecialDiscountType"
                                 [_specialDiscountStatus]="customer.SpecialDiscountStatus"
                                 (changedVisibleCustomerManageDiscountDialog)="changedVisibleCustomerManageDiscountDialogEmit($event)"/>

<p-sidebar [(visible)]="isVisibleCustomerInfo"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width: sidebarWidth}">
    <ng-template pTemplate="header">
        <div class="flex justify-content-between align-items-start w-full" style="margin: 10px 0 0 5px;" *ngIf="customer">
            <div>
                <div class="text-xl font-bold" style="color: #333333;">{{customer.UserName}}</div>
                <div class="text-sm" style="color: #999;">User ID <span class="font-medium" style="color: #3b82f6;">{{customer.Id}}</span></div>
            </div>
            <div>
                <ng-container *ngIf="isBanned">
                    <span class="status-banned">Banned</span>
                </ng-container>
                <ng-container *ngIf="isSuspended && !isBanned">
                    <span class="status-suspended-badge">Suspended</span>
                </ng-container>
                <ng-container *ngIf="!isBanned && !isSuspended">
                    <span class="status-active-badge">Active</span>
                </ng-container>
            </div>
        </div>
    </ng-template>
    <div *ngIf="customer">
        <p-scrollPanel [style]="{width:'100%', height: '100%'}"
                       [styleClass]="'app-scrollpanel'">
            <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

            <div class="customer-info-body" *ngIf="activeTab===customerDetailsTab.Details">
                <p-scrollPanel [style]="{width:'100%', height: '100%'}"
                               [styleClass]="'app-scrollpanel'">
                    <div class="main-info-block">
                        <div class="customer-info-image" style="background-image: url({{customer.ImageUrl}}), url('/XpressApp/assets/images/default-user-image.png')"></div>
                        <div style="margin-left: 40px">
                            <div *ngIf="!showEditFields" class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Full Name</div>
                                <div class="customer-info-basic-field">{{customer.UserName}}</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Gender</div>
                                <div class="customer-info-basic-field">{{customer.Gender}}</div>
                            </div>
                            <div *ngIf="showEditFields" class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">First Name</div>
                                <div><input type="text" pInputText class="p-inputtext-sm" [(ngModel)]="customer.FirstName" placeholder="First Name"></div>
                            </div>
                            <div *ngIf="showEditFields" class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Last Name</div>
                                <div><input type="text" pInputText class="p-inputtext-sm" [(ngModel)]="customer.LastName" placeholder="Last Name"></div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Phone</div>
                                <div class="customer-info-basic-field">{{customer.Phone}}</div>
                            </div>
                            <div *ngIf="!showEditFields" class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Email</div>
                                <div class="customer-info-basic-field">{{customer.Email}}</div>
                            </div>
                            <div *ngIf="showEditFields" class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Email</div>
                                <div><input type="text" pInputText class="p-inputtext-sm" [(ngModel)]="customer.Email" placeholder="email@example.com"></div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Date of birth</div>
                                <div class="customer-info-basic-field">{{customer.BirthDate}}</div>
                            </div>
                        </div>
                    </div>
                    <div style="border-bottom: 1px solid #004060; opacity: 0.3; margin: 30px 0px; "></div>
                    <div class="flex flex-row flex-wrap">
                        <div class="customer-info-50">
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Signup Date:</div>
                                <div class="customer-info-basic-field">{{customer.SignupDate}}</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Signup Type:</div>
                                <div class="customer-info-basic-field">{{customer.SignupType}}</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Was Referred?</div>
                                <div class="customer-info-basic-field">{{(customer.WasReferred) ? 'Yes' : 'No'}}</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Referrer:</div>
                                <div class="customer-info-basic-field">{{customer.Referred}}</div>
                            </div>
                        </div>
                        <div class="customer-info-50">
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">External Links:</div>
                                <div class="customer-info-basic-field">
                                    <span class="customer-info-field-link">{{(customer.LoginProvider) ? customer.LoginProvider : 'Xpress'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br /><br />
                    <div class="flex flex-row flex-wrap">
                        <div class="customer-info-50">
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Last Login:</div>
                                <div class="customer-info-basic-field">{{customer.LastLoginText}}</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Last Completed:</div>
                                <div class="customer-info-basic-field">
                                    <span class="customer-info-field-black-link" *ngIf="customer.LastCompletedText" (click)="openSidebarDisplayOrderDetail()">{{customer.LastCompletedText}}</span>
                                </div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Customer Tier:</div>
                                <div class="customer-info-basic-field">{{(customer.CustomerTier) ? customer.CustomerTier : 'N/A'}}</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Complete Orders:</div>
                                <div class="customer-info-basic-field">{{customer.CompleteOrders}}</div>
                            </div>
                        </div>
                        <div class="customer-info-50">
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Customer Value:</div>
                                <div class="customer-info-basic-field">Top {{customer.CustomerValue}}%</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Avg time per TX:</div>
                                <div class="customer-info-basic-field">{{customer.AvgTimePerTX}} days</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Most popular service:</div>
                                <div class="customer-info-basic-field">{{customer.MostPopularServiceType}}</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Has referred?</div>
                                <div class="customer-info-basic-field">{{(customer.HasReferred) ? 'Yes' : 'No'}} ({{customer.CountReferred}})</div>
                            </div>
                        </div>
                    </div>
                </p-scrollPanel>

                <div *ngIf="hasAccessToAdjustWallet" class="flex flex-row align-items-center gap-2" style="padding: 10px">
                    <div style="width: 300px;">
                        <p class="m-0">Beta Features</p>
                        <p-multiSelect [options]="betaFeatureList"
                                       placeholder="Select Beta Features"
                                       optionLabel="label"
                                       optionValue="value"
                                       [(ngModel)]="selectedBetaFeatures"
                                       [ngStyle]="{'width': '100%', 'min-height': '40px', 'display': 'inline-block'}"
                                       appendTo="body">
                        </p-multiSelect>
                    </div>
                    <button pButton pRipple type="button" class="p-button-primary"
                            label="Update Beta Features "
                            (click)="updateUserBetaFeatures()">
                    </button>
                </div>

                <send-logs-request *ngIf="showLogsRequest" [userId]="customerId"></send-logs-request>

            </div>

            <div class="customer-info-body" *ngIf="activeTab===customerDetailsTab.Finance">
                <div>
                    <div class="flex flex-row flex-wrap">
                        <div class="customer-info-50">
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Total Spend:</div>
                                <div class="customer-info-basic-field">₱ {{userAdditionalInfo?.TotalSpend}}</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Avg spend per TX:</div>
                                <div class="customer-info-basic-field">₱ {{userAdditionalInfo?.AvgSpend}}</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Highest TX:</div>
                                <div class="customer-info-basic-field">₱ {{userAdditionalInfo?.HighestSpend}}</div>
                            </div>
                        </div>
                        <div class="customer-info-50">
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Wallet Active?</div>
                                <div class="customer-info-basic-field">{{(userAdditionalInfo?.WalletActive) ? 'Yes' : 'No'}}</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Wallet Value:</div>
                                <div class="customer-info-basic-field">₱ {{userAdditionalInfo?.WalletValue}}</div>
                            </div>
                            <div class="flex flex-row customer-info-margin-field">
                                <div class="label-person-info-width">Last top up:</div>
                                <div *ngIf="userAdditionalInfo?.WalletLastTopUpDate" class="customer-info-basic-field">{{userAdditionalInfo.WalletLastTopUpDate}} (₱{{userAdditionalInfo.WalletLastTopUp}})</div>
                                <div *ngIf="!userAdditionalInfo?.WalletLastTopUpDate" class="customer-info-basic-field">N/A</div>
                            </div>
                        </div>
                    </div>
                    <div class="customer-info-border-bottom"></div>
                    <div class="customer-info-title">Transactions</div>
                    <div>
                        <p-table #userTransactionsGrid
                                 [columns]="transactionsCols"
                                 [value]="userAdditionalInfo?.Transactions"
                                 [lazy]="true"
                                 dataKey="Id"
                                 (onLazyLoad)="handleLazyLoad($event)"
                                 [loading]="isFinanceTransactionsLoading"
                                 [paginator]="true"
                                 [showFirstLastIcon]="false"
                                 [(first)]="first"
                                 [rows]="rowsPerPage"
                                 [totalRecords]="totalRecords"
                                 [resizableColumns]="false"
                                 [autoLayout]="true"
                                 [styleClass]="'p-datatable-gridlines customer-transactions-table'"
                                 [scrollable]="true"
                                 [scrollHeight]="'flex'"
                                 [style]="{height: 'calc(100vh - 455px)'}">
                            <ng-template pTemplate="caption">
                                <div class="flex justify-content-between">
                                    <div class="flex">
                                        <div class="p-input-icon-left">
                                            <i class="pi pi-search"></i>
                                            <input pInputText type="text" class="search-input"
                                                   [(ngModel)]="filterSearch" (input)="handleFilterChange()"
                                                   placeholder="Search here..." />
                                        </div>
                                    </div>
                                    <div>
                                        <p-overlayPanel #opFilter>
                                            <div class="filte-title">Filter</div>
                                            <div>
                                                <div class="filter-transaction-title">Transaction</div>
                                                <div class="filter-transaction-radiobtn-block">
                                                    <p-radioButton name="transaction" [value]="xpressDeliveryPaymentMethod.XpressUserWallet" [(ngModel)]="filter.transaction" inputId="filter1"></p-radioButton>
                                                    <label for="filter1" class="ml-2">Wallet funding</label>
                                                </div>
                                                <div class="filter-transaction-radiobtn-block">
                                                    <p-radioButton name="transaction" [value]="xpressDeliveryPaymentMethod.PaymentCard" [(ngModel)]="filter.transaction" inputId="filter2"></p-radioButton>
                                                    <label for="filter2" class="ml-2">Payment</label>
                                                </div>
                                                <div class="filter-transaction-radiobtn-block">
                                                    <p-radioButton name="transaction" [value]="xpressDeliveryPaymentMethod.Cash" [(ngModel)]="filter.transaction" inputId="filter3"></p-radioButton>
                                                    <label for="filter3" class="ml-2">Cash In</label>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="filter-transaction-title">Status</div>
                                                <div class="flex flex-row">
                                                    <span class="filter-transaction-status-btn"
                                                          [class.status-btn-active]="filter.status === null"
                                                          (click)="changeFilterStatus()">All</span>
                                                    <span class="filter-transaction-status-btn"
                                                          [class.status-btn-active]="filter.status === true"
                                                          (click)="changeFilterStatus(true)">Successful</span>
                                                    <span class="filter-transaction-status-btn"
                                                          [class.status-btn-active]="filter.status === false"
                                                          (click)="changeFilterStatus(false)">Unsuccessful</span>
                                                </div>
                                            </div>
                                            <div class="flex justify-content-end mt-3">
                                                <button pButton pRipple type="button" label="Clear" class="outlined-white-btn padding-btn mr-3"
                                                        (click)="clickClearFilter()"></button>
                                                <button pButton pRipple type="button" label="Apply" class="bluedark-btn-filter padding-btn"
                                                        (click)="getUserTransactions(0)"></button>
                                            </div>
                                        </p-overlayPanel>
                                        <div class="filters-container">
                                            <p-calendar class="filter-calendar" [(ngModel)]="filterSearchDate"
                                                        [showIcon]="true" selectionMode="range"
                                                        placeholder="Date & Time"
                                                        (ngModelChange)="handleFilterChange()">
                                            </p-calendar>
                                            <button (click)="opFilter.toggle($event)" pButton pRipple type="button"
                                                    label="Filter" class="p-button-outlined p-button-secondary filter-btn"
                                                    style="height: 43px;"></button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th *ngFor="let col of transactionsCols"
                                        [pSortableColumn]="col.field"
                                        [pSortableColumnDisabled]="col.disableSort"
                                        pResizableColumn
                                        [style.width]="col.width">
                                        {{col.header}}
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-transaction>
                                <tr>
                                    <td class="ui-resizable-column">
                                        <div class="flex flex-row">
                                            <div>
                                                <div class="finance-icon-bg bg-green" *ngIf="transaction.Amount > 0">
                                                    <img src="/XpressApp/assets/images/icon_earning.svg" />
                                                </div>
                                                <div class="finance-icon-bg bg-red" *ngIf="transaction.Amount < 0">
                                                    <img src="/XpressApp/assets/images/icon_withdraw.svg" />
                                                </div>
                                            </div>
                                            <div>
                                                <div class="finance-datatime-block finance-datetime-single-line">
                                                    <span class="finance-data">{{transaction.CreatedAtText}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="ui-resizable-column">
                                        {{transaction.TransactionTypeName}}
                                    </td>
                                    <td class="ui-resizable-column">
                                        {{transaction.CardType}} {{transaction.Last4}}
                                    </td>
                                    <td class="ui-resizable-column">
                                        {{(transaction.IsPaid) ? 'Successful' : 'Unsuccessful'}}
                                    </td>
                                    <td class="ui-resizable-column">
                                        <span [ngStyle]="{'color': transaction.AmountColor}">{{transaction.AmountStr}}</span>
                                    </td>
                                    <td class="ui-resizable-column">
                                        <span (click)="showCustomerTransactionDetail(transaction)" class="customer-infor-bottom-line">{{transaction.Id}}</span>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="paginatorleft" let-state>
                                <div *ngIf="userAdditionalInfo?.Transactions" style="padding-left: 10px">
                                    Showing {{first + 1}} to {{first + userAdditionalInfo.Transactions.length}} of {{totalRecords}} entries
                                </div>
                            </ng-template>
                        </p-table>
                        <button pButton pRipple
                                class="p-element btn-darkblue p-button p-component"
                                (click)="showPopupRefundTransaction()">
                            Adjust Wallet Balance
                        </button>
                    </div>
                </div>
            </div>

            <div class="customer-info-body" *ngIf="activeTab===customerDetailsTab.OrderHistory">
                <div class="flex flex-row flex-wrap">
                    <div class="customer-info-50">
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Total Completed:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.TotalCompleted}}</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Total Cancelled:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.TotalCanceled}}</div>
                        </div>
                    </div>
                    <div class="customer-info-50">
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Most Popular Service:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.MostPopularService}}</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Most Popular Partner:</div>
                            <div class="customer-info-basic-field">N/A</div>
                        </div>
                    </div>
                </div>
                <div class="customer-info-border-bottom"></div>
                <div class="customer-info-title">Transactions</div>
                <div>
                    <p-table #userTransactionsGrid
                             [columns]="ordersHistoryCols"
                             [value]="userAdditionalInfo?.OrdersHistory"
                             [lazy]="true"
                             responsiveLayout="scroll" dataKey="Id"
                             (onLazyLoad)="handleLazyLoad($event)"
                             [paginator]="true"
                             [showFirstLastIcon]="false"
                             [(first)]="first"
                             [rows]="rowsPerPage"
                             [totalRecords]="totalRecords"
                             [resizableColumns]="true"
                             [columnResizeMode]="'expand'"
                             [autoLayout]="true"
                             [styleClass]="'p-datatable-gridlines'"
                             [scrollable]="true"
                             [scrollHeight]="'flex'"
                             [style]="{height: 'calc(100vh - 405px)'}">
                        <ng-template pTemplate="caption">
                            <div class="flex justify-content-between">
                                <div class="flex">
                                    <div class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text" class="search-input"
                                               [(ngModel)]="filterSearch" (input)="handleFilterChange()"
                                               placeholder="Search here..." />
                                    </div>

                                </div>
                                <div>
                                    <p-overlayPanel #opOrderFilter>

                                        <div class="mg-side10">
                                            <div class="filter-transaction-title">Service</div>
                                            <div class="field-checkbox" *ngFor="let type of serviceTypeList">
                                                <p-checkbox name="serviceTypeGroup" [value]="type.value" [label]="type.name"
                                                            [(ngModel)]="selectedServiceTypes"></p-checkbox>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="filter-transaction-title">Status</div>
                                            <div class="flex flex-row">
                                                <span class="filter-transaction-status-btn"
                                                      [class.status-btn-active]="filter.status === null"
                                                      (click)="changeFilterStatus()">All</span>
                                                <span class="filter-transaction-status-btn"
                                                      [class.status-btn-active]="filter.status === true"
                                                      (click)="changeFilterStatus(true)">Successful</span>
                                                <span class="filter-transaction-status-btn"
                                                      [class.status-btn-active]="filter.status === false"
                                                      (click)="changeFilterStatus(false)">Unsuccessful</span>
                                            </div>
                                        </div>
                                        <div class="flex justify-content-end mt-3">
                                            <button pButton pRipple type="button" label="Clear" class="outlined-white-btn padding-btn mr-3"
                                                    (click)="clickClearFilter()"></button>
                                            <button pButton pRipple type="button" label="Apply" class="bluedark-btn-filter padding-btn"
                                                    (click)="getUserOrdersHistory(0)"></button>
                                        </div>
                                    </p-overlayPanel>
                                    <div class="filters-container">
                                        <p-calendar class="filter-calendar" [(ngModel)]="filterSearchDate"
                                                    [showIcon]="true" selectionMode="range"
                                                    placeholder="Date & Time"
                                                    (ngModelChange)="handleFilterChange()">
                                        </p-calendar>
                                        <button (click)="opOrderFilter.toggle($event)" pButton pRipple type="button"
                                                label="Filter" class="p-button-outlined p-button-secondary filter-btn"
                                                style="height: 43px;"></button>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th *ngFor="let col of ordersHistoryCols"
                                    [pSortableColumn]="col.field"
                                    [pSortableColumnDisabled]="col.disableSort"
                                    pResizableColumn
                                    [style.width]="col.width">
                                    {{col.header}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-orderHistory>
                            <tr>
                                <td class="ui-resizable-column">
                                    <div class="finance-datatime-block">
                                        <span class="finance-data">{{orderHistory.CreatedAtDate}}</span>
                                        <br />
                                        <span class="finance-time">{{orderHistory.CreatedAtTime}}</span>
                                    </div>
                                </td>
                                <td class="ui-resizable-column">
                                    {{orderHistory.Service}}
                                </td>
                                <td class="ui-resizable-column">
                                    {{(orderHistory.IsPaid) ? 'Successful' : 'Unsuccessful'}}
                                </td>
                                <td class="ui-resizable-column">
                                    <span [ngStyle]="{'color': orderHistory.ValueColor}">{{orderHistory.ValueStr}}</span>
                                </td>
                                <td class="ui-resizable-column">
                                    <div *ngFor="let txnId of orderHistory.TransactionIds">
                                        <span class="customer-infor-bottom-line" (click)="showCustomerOrderDetail(txnId)">TXN-{{txnId}}</span>
                                    </div>
                                </td>
                                <td class="ui-resizable-column">
                                    {{orderHistory.BookingId}}
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="paginatorleft" let-state>
                            <div *ngIf="userAdditionalInfo?.OrdersHistory" style="padding-left: 10px">
                                <ng-container *ngIf="userAdditionalInfo?.OrdersHistory?.length === 0">No Transactions found</ng-container>
                                <ng-container *ngIf="userAdditionalInfo?.OrdersHistory?.length !== 0">Showing {{first + 1}} to {{first + userAdditionalInfo?.OrdersHistory.length}} of {{totalRecords}} entries</ng-container>
                            </div>
                        </ng-template>
                    </p-table>
                </div>
            </div>

            <div class="customer-info-body" *ngIf="activeTab===customerDetailsTab.Referrals">
                <div class="flex flex-row flex-wrap" style="margin: 25px 0;">
                    <div class="customer-info-50">
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Referred users:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.ReferredUsers}}</div>
                        </div>
                    </div>
                    <div class="customer-info-50">
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Value of users:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.TotalSpendUsers}}</div>
                        </div>
                    </div>
                </div>
                <div class="customer-info-border-bottom"></div>
                <div class="customer-info-title">Transactions</div>
                <div>
                    <p-table #userRefferalsGrid
                             [columns]="refferalsCols"
                             [value]="userAdditionalInfo?.Transactions"
                             responsiveLayout="scroll" dataKey="Id"
                             [resizableColumns]="true"
                             [columnResizeMode]="'expand'"
                             [autoLayout]="true"
                             [styleClass]="'p-datatable-gridlines'"
                             [scrollable]="true"
                             [scrollHeight]="'flex'"
                             [style]="{height: 'calc(100vh - 405px)'}">
                        <ng-template pTemplate="header">
                            <tr>
                                <th *ngFor="let col of refferalsCols"
                                    [pSortableColumn]="col.field"
                                    [pSortableColumnDisabled]="col.disableSort"
                                    pResizableColumn
                                    [style.width]="col.width">
                                    {{col.header}}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-transaction>
                            <tr>
                                <td class="ui-resizable-column">
                                    <div class="finance-datatime-block">
                                        <span class="finance-data">{{transaction.CreatedAtDate}}</span>
                                        <br />
                                        <span class="finance-time">{{transaction.CreatedAtTime}}</span>
                                    </div>
                                </td>
                                <td class="ui-resizable-column">
                                    {{transaction.UserName}}
                                </td>
                                <td class="ui-resizable-column">

                                </td>
                                <td class="ui-resizable-column">
                                    <span style="color: #1CBA70;">{{transaction?.TotalSpend}}</span>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>

            <div class="customer-insight-info-body" *ngIf="activeTab===customerDetailsTab.Insights">
                <div class="flex flex-row flex-wrap gap-2">
                    <div class="customer-info-50 insight-service-block">
                        <div class="flex flex-row">
                            <div class="insight-service-img">
                                <img src="/XpressApp/assets/images/car-red.svg" />
                            </div>
                            <div class="insight-service-name">Ride</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Most used Service:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.MostUsedServiceRide}}</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Avg Bookings per week:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.AvgBookingPreWeekRide}}</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Total Category spend:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.TotalRide}}</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Usual booking time:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.UsualBookingTimeRide}}</div>
                        </div>
                    </div>
                    <div class="customer-info-50 insight-service-block">
                        <div class="flex flex-row">
                            <div class="insight-service-img">
                                <img src="/XpressApp/assets/images/delivery.svg" />
                            </div>
                            <div class="insight-service-name">Send</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Most used Service:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.MostUsedServiceDelivery}}</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Avg Bookings per week:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.AvgBookingPreWeekDelivery}}</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Total Category spend:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.TotalDelivery}}</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Usual booking time:</div>
                            <div class="customer-info-basic-field">N/A</div>
                        </div>
                    </div>

                    <div class="customer-info-50 insight-service-block">
                        <div class="flex flex-row">
                            <div class="insight-service-img">
                                <img src="/XpressApp/assets/images/food.svg" />
                            </div>
                            <div class="insight-service-name">Eats</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Most ordered product:</div>
                            <div class="customer-info-basic-field">N/A</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Most popular store:</div>
                            <div class="customer-info-basic-field">N/A</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Total Category spend:</div>
                            <div class="customer-info-basic-field">₱ 0.00</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Usual order time:</div>
                            <div class="customer-info-basic-field">N/A</div>
                        </div>
                    </div>
                    <div class="customer-info-50 insight-service-block">
                        <div class="flex flex-row">
                            <div class="insight-service-img">
                                <img src="/XpressApp/assets/images/grocery.svg" />
                            </div>
                            <div class="insight-service-name">Mart</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Most ordered product:</div>
                            <div class="customer-info-basic-field">N/A</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Most popular store:</div>
                            <div class="customer-info-basic-field">N/A</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Total Category spend:</div>
                            <div class="customer-info-basic-field">₱ 0.00</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Normal shopping day:</div>
                            <div class="customer-info-basic-field">N/A</div>
                        </div>
                    </div>

                    <div class="customer-info-50 insight-service-block">
                        <div class="flex flex-row">
                            <div class="insight-service-name">Payment Method</div>
                        </div>
                        <br />
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Most used method:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.MostUsedPayment}}</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Avg Xpay Top up:</div>
                            <div class="customer-info-basic-field">N/A</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Total spend:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.TotalSpendPayment}}</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width"></div>
                            <div class="customer-info-basic-field persent-field">{{userAdditionalInfo?.PercentageIncrease}}%</div>
                        </div>
                    </div>

                    <div class="customer-info-50 insight-service-block">
                        <div class="flex flex-row">
                            <div class="insight-service-img">
                                <img src="/XpressApp/assets/images/rating_star.svg" />
                            </div>
                            <div class="insight-service-name">Rating</div>
                        </div>
                        <div class="flex flex-row customer-info-margin-field">
                            <div class="label-person-info-width">Customer Rating:</div>
                            <div class="customer-info-basic-field">{{userAdditionalInfo?.CustomerRating}}</div>
                        </div>
                    </div>
                </div>
            </div>

        </p-scrollPanel>

        <div *ngIf="activeTab===customerDetailsTab.Details && isSuspended && !isBanned" class="restriction-details-section" style="padding: 0 15px;">
            <h4 class="font-bold text-color m-0 mb-1">Restriction Details</h4>
            <p class="text-sm text-color-secondary m-0 mb-3">Initial suspension data captured when this customer was suspended.</p>
            <div class="restriction-details-table">
                <div class="restriction-row">
                    <div class="restriction-label">Initial Suspension Reason</div>
                    <div class="restriction-value">{{suspendReason}}</div>
                </div>
                <div class="restriction-row">
                    <div class="restriction-label">Other Details</div>
                    <div class="restriction-value">{{suspendNotes || '-'}}</div>
                </div>
            </div>
        </div>

        <div *ngIf="activeTab===customerDetailsTab.Details && isBanned" class="restriction-details-section" style="padding: 0 15px;">
            <h4 class="font-bold text-color m-0 mb-1">Restriction Details</h4>
            <p class="text-sm text-color-secondary m-0 mb-3">Initial ban data captured when this customer was banned.</p>
            <div class="restriction-details-table">
                <div class="restriction-row">
                    <div class="restriction-label">Initial Ban Reason</div>
                    <div class="restriction-value">{{banReason}}</div>
                </div>
                <div class="restriction-row">
                    <div class="restriction-label">Other Details</div>
                    <div class="restriction-value">{{banNotes || '-'}}</div>
                </div>
            </div>
        </div>

        <div *ngIf="activeTab===customerDetailsTab.Details" class="flex flex-wrap justify-content-center gap-2 py-3" style="padding: 0 15px;">
            <button pButton pRipple type="button"
                    class="p-button-outlined p-button-secondary p-button-sm"
                    label="Manage Disc."
                    (click)="showManageDiscountDialog()"></button>

            <button pButton pRipple type="button"
                    class="p-button-outlined p-button-secondary p-button-sm"
                    label="{{ customer?.IsCompanyUser ? 'Remove from Company' : 'Add to Campaign' }}"
                    (click)="showConfirmDialog()"></button>

            <button pButton pRipple type="button"
                    class="p-button-outlined p-button-secondary p-button-sm"
                    label="{{ customer?.HasUserSubscription ? 'Remove Loop Pass' : 'Buy Loop Pass' }}"
                    (click)="showSubscriptionConfirmDialog()"></button>

            <button *ngIf="!isSuspended && !isBanned" pButton pRipple type="button" label="Suspend"
                    class="p-button p-button-danger p-button-sm"
                    (click)="showModalSuspend(customer)"></button>

            <button *ngIf="isSuspended && !isBanned" pButton pRipple type="button" label="Ban"
                    class="p-button p-button-danger p-button-sm"
                    (click)="showModalBanned(customer)"></button>

            <button *ngIf="isSuspended && !isBanned" pButton pRipple type="button" label="Lift Suspension"
                    class="p-button p-button-success p-button-sm"
                    (click)="showModalLiftSuspension(customer)"></button>

            <button *ngIf="isBanned" pButton pRipple type="button" label="Lift ban"
                    class="p-button p-button-success p-button-sm"
                    (click)="showModalBanned(customer)"></button>
        </div>
    </div>

    <!--<div style="display: flex; position: absolute; right: 20px; bottom: 0px; z-index:3">
        <div *ngIf="!showEditFields">
            <button pButton pRipple type="button" label="Edit" (click)="setShowEditFields()"></button>
        </div>
        <div *ngIf="showEditFields">
            <button pButton pRipple type="button" label="Save & Exit" class="p-button-success" (click)="updatePersonalInfo()"></button>
        </div>
    </div>-->
</p-sidebar>

<p-toast position="top-right"></p-toast>

<p-dialog [(visible)]="showDialogRefundTransaction"
          [modal]="true"
          [style]="{width: '630px', height: '70%'}"
          [draggable]="false"
          [resizable]="false">
    <div class="m-0 refund-body">
        <p class="refund-title">Adjust Wallet Balance</p>
        <p class="refund-description">Are you sure you want to adjust wallet balance?</p>
        <div class="refund-textarea-margin">
            <label>Philippine peso *</label>
            <p-inputNumber [(ngModel)]="adjustWalletBalanceAmount"
                           (ngModelChange)="checkValidation()"
                           buttonLayout="horizontal"
                           mode="currency"
                           currency="PHP"></p-inputNumber>
        </div>
        <div class="refund-textarea-margin">
            <label>Transaction type *</label>
            <p-dropdown [options]="adjustWalletBalanceType"
                        [(ngModel)]="selectedAdjustWalletBalanceType"
                        (ngModelChange)="checkValidation()"
                        placeholder="Transaction type"
                        optionLabel="Name"
                        [showClear]="false"></p-dropdown>
        </div>
        <div class="refund-textarea-margin">
            <label>Transaction description *</label>
            <textarea rows="5"
                      cols="30"
                      pInputTextarea
                      placeholder="Transaction description"
                      (ngModelChange)="checkValidation()"
                      [(ngModel)]="adjustWalletBalanceDescription"></textarea>
        </div>
    </div>
    <div class="modal-buttons-container">
        <button pButton
                icon="pi pi-check"
                class="p-element btn-darkblue p-button p-component mr-1"
                (click)="adjustWalletBalance()"
                [disabled]="!isValidAmount || selectedAdjustWalletBalanceType?.Id === 0 || isRefundApplyButtonDisabled"
                label="Confirm"></button>
        <button pButton
                icon="pi pi-times"
                label="Cancel"
                (click)="hideDialogRefundTransaction()"
                class="p-element btn-cancel p-button p-component"></button>
    </div>
</p-dialog>